function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.99939 12.0001C5.73083 12.0001 5.474 11.8939 5.28357 11.7032L3.04626 9.46576C2.6488 9.07202 2.6488 8.4314 3.04626 8.03448C3.43982 7.63763 4.08044 7.63763 4.47693 8.03448L4.99939 8.5564V1.00012C4.99939 0.447021 5.44568 0.00012207 5.99939 0.00012207C6.55212 0.00012207 6.99939 0.447021 6.99939 1.00012V8.5564L7.52087 8.03448C7.71814 7.83765 7.97693 7.73761 8.23669 7.73761C8.49646 7.73761 8.75525 7.83765 8.95251 8.03448C9.349 8.42822 9.349 9.06885 8.95251 9.46576L6.71521 11.7032C6.5238 11.8939 6.26794 12.0001 5.99939 12.0001Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99939 12.0001C9.99939 11.447 10.4467 11.0001 10.9994 11.0001C11.5521 11.0001 11.9994 11.447 11.9994 12.0001V16.0001H-0.000610352V12.0001C-0.000610352 11.447 0.446655 11.0001 0.99939 11.0001C1.55212 11.0001 1.99939 11.447 1.99939 12.0001V14.0001H9.99939V12.0001Z",
  fill: "#6B6C7E"
});

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "#6B6C7E",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.8816a2fa.svg";
export { ForwardRef as ReactComponent };